var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6665 37.1665H33V52.9998H44.8918C46.4139 52.9998 47.6665 51.6832 47.6665 50.0832V37.1665Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 37.1665V50.0832C14.3333 51.6832 15.65 52.9998 17.25 52.9998H29.75V37.1665H14.3333Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 27.5832V31.7498C51 33.3498 49.8764 34.6665 48.5111 34.6665H48.1556H35V32.1665V24.6665H48.5111C49.8764 24.6665 51 25.9832 51 27.5832Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9167 24.6665H29.75V32.1665V34.6665H14.3333H13.9167C12.3167 34.6665 11 33.3498 11 31.7498V27.5832C11 25.9832 12.3167 24.6665 13.9167 24.6665Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26.4065C31.3633 26.4065 31.71 26.2481 31.945 25.9731C32.1833 25.6981 32.2883 25.3331 32.2366 24.9731C31.62 20.8065 28.365 12.9248 20.4516 12.9248C15.935 12.9265 14.3333 15.3665 14.3333 17.4565C14.3333 21.1715 19.505 26.4065 31 26.4065ZM20.4516 15.4265C26.4216 15.4265 28.6883 21.1015 29.44 23.8698C24.73 23.6498 21.76 22.4581 20.05 21.4431C17.6783 20.0348 16.8333 18.4598 16.8333 17.4548C16.8333 15.9581 18.7016 15.4265 20.4516 15.4265Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9984 26.4068C42.4934 26.4068 47.665 21.1718 47.665 17.4568C47.665 15.3668 46.0617 12.9268 41.545 12.9268C33.6334 12.9268 30.3784 20.8084 29.7617 24.9751C29.71 25.3351 29.815 25.7001 30.0534 25.9751C30.2884 26.2484 30.635 26.4068 30.9984 26.4068ZM41.545 15.4268C43.295 15.4268 45.165 15.9601 45.165 17.4568C45.165 19.5851 41.4434 23.4634 32.56 23.8718C33.31 21.1018 35.5767 15.4268 41.545 15.4268Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6665 38.1665H34.2498V53.9998H46.7498C48.3498 53.9998 49.6665 52.6832 49.6665 51.0832V38.1665Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 38.1665V51.0832C16.3333 52.6832 17.65 53.9998 19.25 53.9998H31.75V38.1665H16.3333Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28.5832V32.7498C53 34.3498 51.6833 35.6665 50.0833 35.6665H49.6667H34.25V33.1665V25.6665H50.0833C51.6833 25.6665 53 26.9832 53 28.5832Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9167 25.6665H31.75V33.1665V35.6665H16.3333H15.9167C14.3167 35.6665 13 34.3498 13 32.7498V28.5832C13 26.9832 14.3167 25.6665 15.9167 25.6665Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27.4065C33.3633 27.4065 33.71 27.2481 33.945 26.9731C34.1833 26.6981 34.2883 26.3331 34.2366 25.9731C33.62 21.8065 30.365 13.9248 22.4516 13.9248C17.935 13.9265 16.3333 16.3665 16.3333 18.4565C16.3333 22.1715 21.505 27.4065 33 27.4065ZM22.4516 16.4265C28.4216 16.4265 30.6883 22.1015 31.44 24.8698C26.73 24.6498 23.76 23.4581 22.05 22.4431C19.6783 21.0348 18.8333 19.4598 18.8333 18.4548C18.8333 16.9581 20.7016 16.4265 22.4516 16.4265Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9984 27.4068C44.4934 27.4068 49.665 22.1718 49.665 18.4568C49.665 16.3668 48.0617 13.9268 43.545 13.9268C35.6334 13.9268 32.3784 21.8084 31.7617 25.9751C31.71 26.3351 31.815 26.7001 32.0534 26.9751C32.2884 27.2484 32.635 27.4068 32.9984 27.4068ZM43.545 16.4268C45.295 16.4268 47.165 16.9601 47.165 18.4568C47.165 20.5851 43.4434 24.4634 34.56 24.8718C35.31 22.1018 37.5767 16.4268 43.545 16.4268Z",
    fill: "white"
  })));
};

export default __webpack_public_path__ + "static/media/gift.7313506a.svg";
export { SvgGift as ReactComponent };